import MuiSvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export interface ISvgIconProps extends SvgIconProps {}

const SvgIcon = (props: ISvgIconProps): JSX.Element => {
  return <MuiSvgIcon {...props} />;
};

export default SvgIcon;
